// Shared "is the user actually looking at the app right now?" check used to
// gate all background polling loops (notifications, chat, announcements).
//
// `document.visibilityState === 'visible'` alone is NOT enough: a tab stays
// "visible" whenever it is the foreground tab of its browser window — even if
// that window is buried behind other apps and the user walked away. That kept
// our pollers firing 24/7 against a left-open tab, burning Railway egress + CPU.
//
// Adding `document.hasFocus()` makes polling pause the instant the browser
// window loses focus (user switches to another app/window), which is exactly
// the "not using the software" state. Polling resumes on focus.

export function isUserActive(): boolean {
  return document.visibilityState === 'visible' && document.hasFocus();
}
